import React from 'react';
import {useSelector} from 'react-redux';
import Utility from '../../../../../../../../../util/utilityfunctions';
import DocumentName from '../../../../../../../../Common/DocumentName/DocumentName';
import CreateEntityForm from '../../../../../Common/CreateEntityForm/CreateEntityForm';
import StyledComponentDocumentLink from './StyledComponentDocumentLink';
import StyledTooltipScrollbar from './StyledTooltipScrollbar';
import StyledToolTipForTable from './StyledToolTipForTable';
import Tooltip from '../Tooltip';
import {OutputText} from '@ey/canvascoreservices';
import {
	actionTags,
	entities as EntityTypes,
	documentTypes,
	groupInvolvementSources
} from '../../../../../../../../../util/uiconstants';
import {toggleFrameModal, useFrameService} from '@ey/canvascoreservices';

export const ComponentName = (item) => {
	const frameService = useFrameService();
	const allEngagementDocuments = useSelector(({entityDocuments}) => entityDocuments?.byId);
	const outputTextProps = {
		light: true,
		body2: true,
		ellipsis: true,
		maxWidth: '55',
		color: 'blue600yellow400',
		style: {cursor: 'pointer'}
	};
	const relatedDocuments =
		allEngagementDocuments !== undefined
			? Object.values(allEngagementDocuments)?.filter((document) => document.smartEvidenceSourceId === item.id)
			: [];
	const renderCreateDocument = (item) => {
		return (
			<CreateEntityForm
				key={`createEntityAccount-${item.id}`}
				createLabel={
					<OutputText {...outputTextProps} title={item.name}>
						{item.name}
					</OutputText>
				}
				showIcon={false}
				showDocuments={false}
				forTable
				entityId={EntityTypes.GaComponent}
				objectIds={[item.id]}
				documentTypeId={documentTypes.GROUP_INVOLVEMENT_INDIVIDUAL_COMPONENT}
				source={groupInvolvementSources.groupInvolvementSummary}
			/>
		);
	};

	const renderComponentDocumentLink = (relatedDocuments, item) => {
		return relatedDocuments.map((document, index) => {
			const isPriorPeriodEvidence = Utility.isPriorPeriodEvidence(document);
			return (
				<StyledComponentDocumentLink className="comp-doc-link">
					<DocumentName
						key={index}
						actionTag={isPriorPeriodEvidence ? actionTags.openReadOnly : actionTags.open}
						engagementId={document.engagementId}
						documentId={document.id}
						documentName={document.documentName}
						documentTypeId={document.documentTypeId}
						documentChangeTypeId={document.documentChangeTypeId}
						documentEditUserName={document.documentEditUserName}
						documentEditUserCreateDate={document.documentEditUserCreateDate}
						entityUId={item.id}
						confidentialityTypeId={document.confidentialityTypeId}
						enableOpenDocument
						fileExt={document.fileExt}
						fileSizeKB={document.fileSizeKB}
						hasComments={document.hasComments}
						hasHiddenSheets={document.hasHiddenSheets}
						hasHighlights={document.hasHighlights}
						hasAnySystemAssociated={document.hasAnySystemAssociated}
						isReadOnly={document.isReadOnly}
						isConflicted={document.isConflicted}
						isDragAndDropDoc={document.isDragAndDrop}
						isShared={document.isShared}
						isReturned={document.isReturned}
						isEPSignoffRequired={document.isEPSignoffRequired}
						isEPSignoffUserRequired={document.isEPSignoffUserRequired}
						isEQRSignoffRequired={document.isEQRSignoffRequired}
						isEQRSignoffUserRequired={document.isEQRSignoffUserRequired}
						lastModifiedFullName={document.lastModifiedFullName + ' '}
						modifiedDate={document.modifiedDate}
						showCurrentUserInfo={false}
						showConfidential={false}
						showMenuOptions={false}
						showLastModifiedUserInfo={false}
						menuOptions={undefined}
						showPriorPeriodMenuOptions={false}
						showShared={false}
						ellipsis
						ellipseMaxLines={1}
						size="medium"
						smartEvidenceSourceId={document.smartEvidenceSourceId}
						trackChange={document.trackChange}
						viewKey={'ACCOUNT_BODY_DOCUMENT'}
					/>
				</StyledComponentDocumentLink>
			);
		});
	};

	const renderComponentWithDoceWithoutTooltip = (document, item) => {
		const title = item.name;
		return (
			<OutputText
				{...outputTextProps}
				title
				onClick={(url) => {
					if (window.self === window.top) {
						toggleFrameModal({
							isAresView: true,
							variant: 'slideout',
							frameArgs: {
								name: document.documentName,
								src: Utility.isDocumentCanvasForm(document.documentTypeId)
									? new URL(window.location.origin) +
									  `fit?engagementid=${document.engagementId}&documentid=${document.id}&isdrawer=true`
									: url
							}
						});
					} else {
						frameService.openFrameFromChild({
							isAresView: true,
							variant: 'slideout',
							frameArgs: {
								name: document.documentName,
								src: Utility.isDocumentCanvasForm(document.documentTypeId)
									? new URL(window.location.origin) +
									  `fit?engagementid=${document.engagementId}&documentid=${document.id}&isdrawer=true`
									: url
							}
						});
					}
				}}
			>
				{title}
			</OutputText>
		);
	};

	const renderComponentWithDocsWithTooltip = (relatedDocuments, item) => {
		const trigger = <OutputText {...outputTextProps}>{item.name}</OutputText>;
		const tooltipProps = {
			placement: 'bottom',
			trigger,
			allowHover: true,
			allowClick: true,
			hideCloseButton: true
		};

		return (
			<StyledToolTipForTable>
				<Tooltip {...tooltipProps}>
					<StyledTooltipScrollbar className="customScrollbar">
						{renderComponentDocumentLink(relatedDocuments, item)}
					</StyledTooltipScrollbar>
				</Tooltip>
			</StyledToolTipForTable>
		);
	};

	if (relatedDocuments.length === 1) {
		return renderComponentWithDoceWithoutTooltip(relatedDocuments[0], item);
	} else if (relatedDocuments.length > 1) {
		return renderComponentWithDocsWithTooltip(relatedDocuments, item);
	} else {
		return renderCreateDocument(item);
	}
};
